// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2DT7I","footer":"ReportModalFilter_footer__hVzhs"};